import { render } from "./Overview.vue?vue&type=template&id=1d608871&scoped=true"
import script from "./Overview.vue?vue&type=script&lang=js"
export * from "./Overview.vue?vue&type=script&lang=js"

import "./Overview.vue?vue&type=style&index=0&id=1d608871&lang=scss"
import "./Overview.vue?vue&type=style&index=1&id=1d608871&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d608871"]])

export default __exports__